export default "__VITE_ASSET__pc4iwMGw__"